// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  display: block;
}

ion-grid {
  padding: 0.375rem 0.375rem 0.75rem;
  background-color: #ffffff;
  margin: 0;
  border-radius: 0.25rem;
  height: 100%;
}
ion-grid .promo-image {
  width: 100%;
  height: 7.06rem;
  object-fit: cover;
}
ion-grid .name {
  margin: 1.5rem 0 1.31rem;
}

@media screen and (max-width: 768px) {
  ion-grid {
    padding: 0.25rem 0.25rem 0.5rem;
  }
  ion-grid .promo-image {
    height: 4.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-promotion-details/popover-promotion-details.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AACJ;;AACA;EACI,kCAAA;EACA,yBAAA;EACA,SAAA;EACA,sBAAA;EACA,YAAA;AAEJ;AAAI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;AAER;AAAI;EACI,wBAAA;AAER;;AAGA;EACI;IACI,+BAAA;EAAN;EAEM;IACI,gBAAA;EAAV;AACF","sourcesContent":[":host {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\nion-grid {\r\n    padding: 0.375rem 0.375rem 0.75rem;\r\n    background-color: #ffffff;\r\n    margin: 0;\r\n    border-radius: 0.25rem;\r\n    height: 100%;\r\n\r\n    .promo-image {\r\n        width: 100%;\r\n        height: 7.06rem; \r\n        object-fit: cover;\r\n    }\r\n    .name {\r\n        margin: 1.5rem 0 1.31rem;\r\n    }\r\n}\r\n\r\n\r\n@media screen and (max-width: 768px) {\r\n    ion-grid {\r\n        padding: 0.25rem 0.25rem 0.5rem;\r\n\r\n        .promo-image{\r\n            height: 4.875rem;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
